import { unauthenticatedClient } from './nearlive';

export async function register(payload) {
	return await unauthenticatedClient.post(`/api/register`, payload);
}
